import { jwtDecode } from "jwt-decode"
import { PinTokenType } from "../types/portalTypes/PinTokenType"

export function errorifInvalidPin(pin: string | null) {
  let decoded: PinTokenType 
  if (!pin) { throw new Error('No Pin provided') }

  try {
    decoded = jwtDecode<PinTokenType>(pin)
  } catch (error) {
    console.error("Invalid token format", error)
    throw new Error('Invalid Pin format', { cause: 'invalid_jwt' })
  }

  const currentTime = Date.now() / 1000

  if (decoded.exp && decoded.exp < currentTime) {
    console.log("JWT has expired")
    throw new Error('Session expired.  Please click try again.', {cause: 'expired_jwt'})
  }
}
